import * as z from "zod";

/** Asks the Recover team to enable or disable non-subscriber outreach for an SMS campaign. */
export const optInToRecoverSmsOutreach = {
  name: "optInToRecoverSmsOutreach" as const,
  input: z.object({ campaignId: z.string(), enabled: z.boolean() }),
  output: z.null(),
};
